// action type is declared
//redux action 1, create action types
export const ADD_COMMENT = 'ADD_COMMENT';

// redux thunk 2
export const DISHES_LOADING = 'DISHES_LOADING';  // fetch the data from server
export const DISHES_FAILED = 'DISHES_FAILED'; //failed to fetch the dishes information from a server
export const ADD_DISHES = 'ADD_DISHES'; // add dishes to the store

//fetch 2
export const ADD_COMMENTS = 'ADD_COMMENTS';
export const COMMENTS_FAILED = 'COMMENTS_FAILED';
export const PROMOS_LOADING = 'PROMOS_LOADING';
export const ADD_PROMOS = 'Add_PROMOS';
export const PROMOS_FAILED = 'PROMOS_FAILED';

//Ass 4 Task 1
export const LEADERS_LOADING = 'LEADERS_LOADING';
export const ADD_LEADERS = 'ADD_LEADERS';
export const LEADERS_FAILED = 'LEADERS_FAILED';
